// extracted by mini-css-extract-plugin
export var acitonButtons = "_br-0";
export var additionalIcon = "_br-f";
export var block = "_br-1";
export var blockContent = "_br-7";
export var blockDescription = "_br-8";
export var blockIcon = "_br-9";
export var blockTitle = "_br-6";
export var border = "_br-a";
export var center = "_br-l";
export var edge = "_br-b";
export var edgeLabel = "_br-c";
export var edgePath = "_br-d";
export var error = "_br-e";
export var flowchart = "_br-g";
export var flowchartContent = "_br-h";
export var highlighted = "_br-3";
export var hover = "_br-4";
export var icon = "_br-i";
export var left = "_br-m";
export var navButton = "_br-j";
export var navButtons = "_br-k";
export var right = "_br-n";
export var selected = "_br-2";
export var small = "_br-5";